import template from './questionTextAndIcon.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    titleValue: '<',
    inputValue: '<',
    applicantAgeDisplayText: '@',
    iconText: '@',
    placeHolder: '@',
    onChange: '&',
  },
};
